// Consentimento de cookies (LGPD) — granular.
//
// Guarda a escolha do visitante em localStorage via safeStorage (nunca lança).
//  - "all"        → aceita todos: medição com cookie de 1ª parte (hl_vid),
//                   permitindo reconhecer visitante recorrente.
//  - "essential"  → apenas essenciais: medição anônima (sem cookie, só hash de IP).
//  - null         → ainda não decidiu (banner é exibido).
//
// Independente da escolha, dados pessoais não são armazenados em claro: o IP é
// sempre anonimizado por hash no backend.

import { safeGet, safeSet } from "./safeStorage";

const KEY = "hl_cookie_consent";

export function getConsent() {
    const value = safeGet(KEY, { kind: "local" });
    // compatibilidade com valores antigos
    if (value === "accepted") return "all";
    if (value === "rejected") return "essential";
    return value; // "all" | "essential" | null
}

export function hasConsentDecision() {
    return getConsent() != null;
}

// Habilita o cookie de visitante (recorrência) — só com aceite total.
export function isTrackingAllowed() {
    return getConsent() === "all";
}

// Nível registrado junto de cada acesso: "all" | "essential" | "none".
export function getConsentLevel() {
    return getConsent() || "none";
}

export function setConsent(value) {
    // value: "all" | "essential"
    safeSet(KEY, value, { kind: "local" });
    // Notifica componentes interessados (banner some, tracking re-avalia).
    try {
        window.dispatchEvent(new CustomEvent("hl-consent-change", { detail: value }));
    } catch {
        /* ambientes sem CustomEvent — ignora */
    }
}
